@if (type) {
  <div
    class="entry-fee-title-type"
    [attr.data-cy]="'entry-fee-container-' + type"
    [ngClass]="{'strategy-item-margin': useStrategyStyling}"
    >
    <span
      class="description"
      [ngClass]="{'dark-color': useStrategyStyling}"
      >
      {{ ('entryFeeCalc.' + typeKeys[type].desc) | translate }}:
    </span>
    <span class="price">
      <div>
        <span
          [ngClass]="{'dark-color': useStrategyStyling}"
          data-cy="entry-fee-total"
          >
          {{ feeIncludingVat | price: currencyCode }}
        </span>
        <div class="d-inline" #explainTooltipButton>
          <svg-icon
            src="assets/icons/question-mark.svg"
            [svgStyle]="{ 'width.px':22, 'height.px':22 }"
            class="question-mark-icon"
          ></svg-icon>
        </div>
      </div>
      @if (feeVat > 0) {
        <div
          class="entry-fee-vat my-0 py-0"
          data-cy="fees-vat-included"
          >
          ({{ 'entryFeeCalc.vatIncluded' | translate }}{{ feeVat | price: currencyCode }})
        </div>
      }
    </span>

    <div #explainTooltipContent style="display: none;">
      <div class="tooltip-content entry-fee-calc-explain-message">
        <span>
          {{ 'entryFeeCalc.explain.fee1' | translate }}
          {{ (feeRatio * 100) | number:'1.0-2' }}
          {{ ('entryFeeCalc.explain.' + typeKeys[type].explain) | translate }}
        </span>
        @if (feeVat > 0) {
          <span>
            {{ 'entryFeeCalc.explain.vat' | translate }}
            {{ feeVat | price: currencyCode }}.
          </span>
        }
        @if (discountRegularDeposit > 0) {
          <span>
            {{ 'entryFeeCalc.explain.discount1' | translate }}
            {{ (discountRegularDeposit * 100) | number:'1.0-2' }}
            {{ 'entryFeeCalc.explain.discount2' | translate }}
          </span>
        }
        <span>
          {{ ('entryFeeCalc.explain.' + typeKeys[type].paymentInfo) | translate }}
        </span>
      </div>
    </div>
  </div>
}
